<template>
	<div class="container sub-top mb-30">
		<div>
			<div class="justify-space-between-pc gap-20">
				<div
					class="flex-1  size-px-14 font-weight-500 box radius-20 pa-20"
				>
					<div class="flex-column justify-space-between full-height">
						<div class="justify-space-between items-center">
							<div class="justify-start items-center">
								<v-icon :class="crown">mdi mdi-crown</v-icon>
								<span class="size-px-24-pc size-px-20-m font-weight-bold color-primary">{{ user.member_id}}({{ user.member_name}})</span> 님
								<span class="size-px-14-m">반갑습니다.</span>
							</div>

							<button
								class="btn-round btn-warning"
								@click="logout"
							>로그아웃</button>
						</div>

						<div class="mt-10">
							<button
								class="btn-round btn-outline hide-m"
								@click="toModify"
							>정보수정</button>
						</div>
					</div>
				</div>
				<div class="flex-1">
					<div
						v-if="user.member_level < 5"
						class=" mt-10-m pa-20 box radius-20 "
					>
						<div class="  size-px-18-pc size-px-16-m ">
							<div class="font-weight-bold hide-m">{{ shop_info.shop_name }} 포인트</div>
							<div class="justify-space-between items-center mt-10">
								<span class="size-px-36-pc size-px-20-m font-weight-bold">{{ user.member_point | makeComma }} P</span>
								<button @click="reload"><v-icon >mdi-refresh</v-icon></button>
							</div>
						</div>
					</div>

					<div
						v-if="is_use_sandpay && user.member_level < 5"
						class="mt-30 flex-column justify-center mt-10-m pa-20 box radius-20 "
					>
						<div class="  size-px-18-pc size-px-16-m ">
							<div class="font-weight-bold hide-m">센드페이 포인트</div>
							<div class="justify-space-between items-center mt-10">
								<span class="size-px-36-pc size-px-20-m font-weight-bold">{{ user.member_point_sandpay | makeComma }} P</span>
								<button @click="reload"><v-icon >mdi-refresh</v-icon></button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			class="mt-30 hide-m"
		>
			<ul
				class="justify-space-between gap-20"
			>
				<template
					v-for="(menu, m_index) in items_menu"
				>
				<li
					v-if="!menu.not_view"
					:key="'menu_' + m_index"
					class="pa-30-10 box radius-20 flex-1 text-center font-weight-bold size-px-16 bg-default cursor-pointer"
					:class="{ on: menu.title == item.title}"
					@click="toMenu(menu)"
				>
					{{ menu.title }}
				</li>
				</template>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'SubTop'
		, props: ['user', 'program', 'codes', 'shop_info']
		, data: function(){
			return {
				items_menu: [
					{
						name: 'point'
						, title: '포인트 내역'
						, to: 'PointHistory'
						, not_view: this.user.member_level < 5 ? false : true
					}
					, {
						name: 'point'
						, title: '포인트 결제 내역'
						, to: 'PointList'
						, not_view: this.user.member_level < 5 ? false : true
					}
					, {
						name: 'present'
						, title: '포인트 선물'
						, to: 'PointPresent'
						, not_view: this.user.member_level < 5 ? false : true
					}
					, {
						name: 'present'
						, title: '주문 내역'
						, to: 'OrderList'
						, params: {
							type: 'order'
						}
					}
					, {
						name: 'issue'
						, title: '취소/환불'
						, to: 'OrderCancel'
						, params: {
							type: 'cancel'
						}
					}
					, {
						name: 'qna'
						, title: '1:1문의'
						, to: 'CustomerCenter'
						, params: {
							b_code: 'b_qna'
						}
					}
					, {
						name: 'wish'
						, title: '관심상품'
						, to: 'Wish'
					}
				]
			}
		}
		, computed: {

			item: function(){
				let t = {
				}

				this.items_menu.filter( (item) => {
					if(item.to == this.$route.name){
						t = item
					}
				})

				return t
			}

			, crown: function(){
				let t = ''

				this.codes.M001.items.filter( (item) => {
					if(item.code_index == this.user.member_level){
						t = 'crown-' + item.code_color
					}
				})

				return t
			}
			, is_use_sandpay: function(){
				let t = false

				if(this.user.is_use_sandpay == 1 && this.shop_info?.program?.is_use_sandpay == "1"){
					if(this.user.member_level > 0 && this.user.member_level < 5){
						t = true
					}
				}

				return t
			}
		}
		, methods: {
			toModify: function(){
				this.$bus.$emit('to', {name: 'MyPage'})
			}
			, toMenu: function(item){
				this.$bus.$emit('to', {name: item.to, params: item.params})
			}
			, reload: function(){
				document.location.reload()
			}
			, logout: function(){
				if(confirm("로그아웃 하시겠습니까?")){
					this.$bus.$emit('logout')
				}
			}
		}
		, created() {

		}
	}
</script>

<style>

	.crown-bronze { color: #CD7F32 !important;}
	.crown-silver { color: silver !important;}
	.crown-gold { color: gold !important;}
	.crown-vip { color: violet !important;}
</style>